var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-picker',{attrs:{"locale":_vm.language,"value":_vm.pickerValue,"is-range":_vm.isRange},on:{"input":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }